import essApi from "../axios/essApi";

class ApiDocService {
    async getSwaggerSpec() {
        return Promise.resolve(essApi.get(`swagger.json`));
    }
}

export default ApiDocService;